// extracted by mini-css-extract-plugin
module.exports = {"logOffTips":"styles_logOffTips__2oxpJ","applist":"styles_applist__3ToFU","sendPhone":"styles_sendPhone__1REc5"};